// @flow
import React, { memo } from "react";
import t from "common/i18n";
import ColorPicker from "root/components/ColorPicker";
import consts from "../../data/consts";

type Props = {
    value: string,
    className: string,
    onChange: Function,
};

const Color = (props: Props) => (<section className={props.className}>
	<label>{t("shutterstock.filters.color")}</label>
	<ColorPicker
		options={consts.COLORS}
		value={props.value}
		onChange={(newValue) => props.onChange({ color: newValue })}
	/>
</section>);

export default memo<Props>(Color);
